import { createUseStyles } from 'react-jss';
import colors from "../../../../utils/colors";

var styles = {
  rates: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },
  rateWrapper: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: '1.2fr 1fr',
    columnGap: '1rem',
    '&:not(:last-child)': {
      marginBottom: '1rem'
    }
  },
  rateName: {
    color: colors.neutral[900],
    font: {
      size: '1.4rem',
      lineHeight: '1.8rem',
      weight: 400
    },
    letterSpacing: '0.02rem'
  },
  rateValue: {
    font: {
      size: '1.4rem',
      lineHeight: '1.8rem',
      weight: 700
    },
    letterSpacing: '0.02rem',
    color: colors.green[600],
    justifySelf: 'end'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map